import React, { useState } from "react";
import styled from "styled-components";

const LinkWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  background-color: #e6f4ea;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  color: #28a745;
  user-select: none;
  transition: background-color 0.3s ease, transform 0.1s;

  &:hover {
    background-color: #d4eddc;
  }

  &:active {
    transform: scale(0.96);
    background-color: #c8e6d0;
  }

  @media (max-width: 768px) {
    padding: 10px 14px;
    font-size: 0.9rem;
    min-height: 44px;
    justify-content: center;
  }
`;

const Tooltip = styled.span`
  margin-left: 10px;
  font-size: 0.8rem;
  color: #666;
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  transition: visibility 0.2s;

  @media (max-width: 768px) {
    font-size: 0.85rem;
    margin-left: 8px;
  }
`;

const CopyableLink = ({ linkId }) => {
    const [copied, setCopied] = useState(false);
    const url = `${window.location.origin}/content/public_links/${linkId}`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    return (
        <LinkWrapper onClick={handleCopy} title="Click to copy">
            {linkId}
            <Tooltip $visible={copied}>Copied!</Tooltip>
        </LinkWrapper>
    );
};

export default CopyableLink;
